export default "__VITE_ASSET__82e4ebd9__"